import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"
import _imports_0 from '@/img/defaultUser.jpg'


const _hoisted_1 = { class: "text-center mt-2" }
const _hoisted_2 = { class: "profileImageContainer" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "avatar",
  src: _imports_0
}
const _hoisted_5 = { class: "editProfileImage" }
const _hoisted_6 = { class: "btn btn-round btn-sm" }
const _hoisted_7 = { class: "mt-4 fw-bold" }
const _hoisted_8 = { class: "mt-1" }
const _hoisted_9 = { class: "px-4" }
const _hoisted_10 = { class: "profileLink" }
const _hoisted_11 = { class: "profileLink" }
const _hoisted_12 = { class: "profileLink" }
const _hoisted_13 = { class: "profileLink" }
const _hoisted_14 = { class: "profileLink" }
const _hoisted_15 = { class: "profileLink" }
const _hoisted_16 = { class: "profileLink" }
const _hoisted_17 = { class: "profileLink" }
const _hoisted_18 = { class: "profileLink" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_20 = { class: "mt-2" }
const _hoisted_21 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_camera = _resolveComponent("icon-camera")!
  const _component_file_input = _resolveComponent("file-input")!
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_icon_chevron_right = _resolveComponent("icon-chevron-right")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.$store.state.user && _ctx.$store.state.user.personalData.profilePicture)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              class: "avatar profileImage",
              src: _ctx.$store.state.user.personalData.profilePicture.publicUrl
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("img", _hoisted_4)),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", _hoisted_6, [
            _createVNode(_component_icon_camera, { style: {"height":"20px","width":"20px"} }),
            _createVNode(_component_file_input, {
              class: "hidden",
              modelValue: _ctx.fileToUpload,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileToUpload) = $event))
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$store.state.user && _ctx.$store.state.user.personalData.completeName), 1),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.$store.state.clubSubscription && ! _ctx.$store.state.agentSubscription)
          ? (_openBlock(), _createBlock(_component_localized_text, {
              key: 0,
              localizedKey: "Utente base",
              text: "Utente base"
            }))
          : (_ctx.$store.state.clubSubscription)
            ? (_openBlock(), _createBlock(_component_localized_text, {
                key: 1,
                localizedKey: "Socio",
                text: "Socio"
              }))
            : (_ctx.$store.state.agentSubscription)
              ? (_openBlock(), _createBlock(_component_localized_text, {
                  key: 2,
                  localizedKey: "Incaricato",
                  text: "Incaricato"
                }))
              : (_ctx.$store.state.clubSubscription && _ctx.$store.state.agentSubscription)
                ? (_openBlock(), _createBlock(_component_localized_text, {
                    key: 3,
                    localizedKey: "Socio e incaricato",
                    text: "Socio e incaricato"
                  }))
                : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, { to: "/village/reviewRules" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Vinci un premio",
              text: "Vinci un premio"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_router_link, { to: "/profile/purchaseHistory" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Acquisti",
              text: "Acquisti"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_router_link, { to: "/network/clubSubscription" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Iscrizione socio AuraClub",
              text: "Iscrizione socio AuraClub"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToAgentSubscription && _ctx.goToAgentSubscription(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Iscrizione incaricato AuraClub",
            text: "Iscrizione incaricato AuraClub"
          }),
          _createVNode(_component_icon_chevron_right)
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_router_link, { to: "/profile/notificationsConfig" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Impostazioni notifiche",
              text: "Impostazioni notifiche"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_router_link, { to: "/profile/profileData" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati personali & privacy",
              text: "Dati personali & privacy"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_router_link, { to: "/profile/fiscalDataPage" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Dati fiscali",
              text: "Dati fiscali"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_router_link, { to: "/profile/faq/0" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Domande frequenti",
              text: "Domande frequenti"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_router_link, { to: "/profile/oblivion" }, {
          default: _withCtx(() => [
            _createVNode(_component_localized_text, {
              localizedKey: "Rimuovi completamente i miei dati",
              text: "Rimuovi completamente i miei dati"
            }),
            _createVNode(_component_icon_chevron_right)
          ]),
          _: 1
        })
      ]),
      _hoisted_19
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Logout",
            text: "Logout"
          })
        ])
      ])
    ])
  ], 64))
}